import React, { FC } from 'react';
import { css } from 'styled-components';
import { up } from 'styled-breakpoints';
import Modal from '@fenderdigital/ui/Modal';
import Button from '@fenderdigital/ui/Button';
import Flex from '@fenderdigital/ui/Flex';
import Heading from '@fenderdigital/ui/Heading';
import Spacer from '@fenderdigital/ui/Spacer';
import Text from '@fenderdigital/ui/BodyText';

interface NonUpgradableModalProps {
  onClose: () => void;
}

const NonUpgradableModal: FC<NonUpgradableModalProps> = ({ onClose }) => {
  const nonUpgradableModalButton = '[data-id="non-upgradable-modal-button"]';
  return (
    <Modal
      ariaLabelledby="non-upgradable-modal-title"
      dataId="non-upgradable-modal"
      colorScheme="dark"
      focusSelector={nonUpgradableModalButton}
      onClose={onClose}
      size="small"
    >
      <Flex align="center" direction="column" justify="center" height="100%">
        <Heading
          alignment="center"
          forwardedAs="h1"
          id="non-upgradable-modal-title"
          textColor="white"
          textSize={[null, 'f6', 'f7']}
          css={css`
            max-width: 15.375rem;
            ${up('tablet-portrait')} {
              max-width: 28.75rem;
            }
            margin-left: auto;
            margin-right: auto;
          `}
        >
          Fender Play Premium is not available in your region yet.
        </Heading>
        <Spacer />
        <Text
          alignment="center"
          dataId="non-upgradable-modal-description"
          fontFamily="futuraBook"
          textColor="white"
          textSize="f3"
          css={`
            max-width: 17rem;
            margin-left: auto;
            margin-right: auto;
          `}
        >
          We’re working on it! We will notify you when it becomes available.
        </Text>
        <Spacer spacing="md4" />
        <Flex align="center" justify="center" width="100%">
          <Button
            colorScheme="white"
            dataId="non-upgradable-modal-button"
            onClick={onClose}
            shape="pill"
            isFluid
            textColor="black"
            css={css`
              text-transform: none;
              ${up('tablet-portrait')} {
                width: 9.375rem;
              }
            `}
          >
            Okay
          </Button>
        </Flex>
        <Spacer spacing="md1" />
      </Flex>
    </Modal>
  );
};

export default NonUpgradableModal;
